// The 3D otter sheets (assets/otters3d, made by `render.mjs --public app/public/otter3d`; don't edit by hand).
// Cells are 32 px, GEO3D.cols a row; animation a, direction d (0 faces down, then clockwise on screen: dirs/4 right),
// frame k is cell GEO3D.anim[a].start + d * GEO3D.anim[a].frames + k. FILES3D: per body, the sheet (base: the body in
// the template colours looks.js recolours) and one overlay per accessory on the same grid; and `act`: the
// same for the act actions, 敲电脑 ... 比心 (GEO3D.act's grid: its own cols / rows / cells / anim, cells numbered from 0).
export const GEO3D = {"cell":32,"cols":24,"rows":22,"cells":509,"dirs":16,"elev":13,"ss":4,"anim":{"idle":{"start":0,"dirs":16,"frames":6,"ms":220},"walk":{"start":96,"dirs":16,"frames":4,"ms":110},"run":{"start":160,"dirs":16,"frames":4,"ms":85},"swim":{"start":224,"dirs":16,"frames":4,"ms":170},"dive":{"start":288,"dirs":16,"frames":3,"ms":160},"float":{"start":336,"dirs":1,"frames":2,"ms":650},"climb":{"start":338,"dirs":16,"frames":3,"ms":250},"emWave":{"start":386,"dirs":1,"frames":3,"ms":160},"emFacepalm":{"start":389,"dirs":1,"frames":3,"ms":300},"emBroke":{"start":392,"dirs":1,"frames":4,"ms":260},"emHug":{"start":396,"dirs":1,"frames":3,"ms":300},"emRaise":{"start":399,"dirs":1,"frames":2,"ms":300},"emClap":{"start":401,"dirs":1,"frames":2,"ms":160},"emHeart":{"start":403,"dirs":1,"frames":2,"ms":300},"sleep":{"start":405,"dirs":1,"frames":4,"ms":700},"sit":{"start":409,"dirs":16,"frames":2,"ms":900},"type":{"start":441,"dirs":16,"frames":4,"ms":140},"emGiggle":{"start":505,"dirs":1,"frames":4,"ms":250}},"layers":["scarf","beanie","straw","captain","flower","glasses","shades","phones","bowtie","swimring"],"bodies":["0","A","B","C","Y","K","M","G"],"act":{"cols":24,"rows":16,"cells":368,"anim":{"catType":{"start":0,"dirs":16,"frames":4,"ms":140},"catPhone":{"start":64,"dirs":16,"frames":3,"ms":300},"catStretch":{"start":112,"dirs":16,"frames":3,"ms":400},"catRub":{"start":160,"dirs":16,"frames":4,"ms":250},"catSpin":{"start":224,"dirs":16,"frames":4,"ms":120},"catAngry":{"start":288,"dirs":16,"frames":2,"ms":160},"catHeart":{"start":320,"dirs":16,"frames":3,"ms":300}}},"duo":{"cols":24,"rows":3,"cells":58,"anim":{"duoHug":{"start":0,"dirs":2,"frames":4,"ms":300},"duoFive":{"start":8,"dirs":2,"frames":4,"ms":200},"duoBoop":{"start":16,"dirs":2,"frames":3,"ms":400},"duoSpin":{"start":22,"dirs":16,"frames":2,"ms":160},"duoFloat":{"start":54,"dirs":2,"frames":2,"ms":650}}}};
export const FILES3D = {
  '0': {
    base: new URL('./otter3d-0.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-0-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-0-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-0-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-0-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-0-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-0-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-0-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-0-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-0-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-0-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-0-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-0-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-0-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-0-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-0-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-0-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-0-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-0-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-0-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-0-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-0-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-0-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-0-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-0-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-0-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-0-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-0-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-0-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-0-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-0-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-0-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-0-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'A': {
    base: new URL('./otter3d-a.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-a-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-a-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-a-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-a-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-a-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-a-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-a-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-a-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-a-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-a-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-a-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-a-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-a-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-a-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-a-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-a-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-a-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-a-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-a-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-a-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-a-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-a-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-a-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-a-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-a-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-a-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-a-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-a-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-a-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-a-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-a-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-a-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'B': {
    base: new URL('./otter3d-b.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-b-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-b-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-b-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-b-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-b-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-b-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-b-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-b-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-b-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-b-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-b-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-b-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-b-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-b-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-b-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-b-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-b-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-b-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-b-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-b-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-b-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-b-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-b-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-b-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-b-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-b-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-b-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-b-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-b-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-b-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-b-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-b-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'C': {
    base: new URL('./otter3d-c.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-c-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-c-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-c-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-c-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-c-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-c-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-c-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-c-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-c-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-c-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-c-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-c-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-c-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-c-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-c-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-c-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-c-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-c-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-c-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-c-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-c-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-c-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-c-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-c-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-c-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-c-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-c-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-c-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-c-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-c-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-c-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-c-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'Y': {
    base: new URL('./otter3d-y.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-y-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-y-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-y-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-y-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-y-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-y-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-y-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-y-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-y-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-y-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-y-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-y-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-y-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-y-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-y-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-y-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-y-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-y-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-y-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-y-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-y-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-y-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-y-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-y-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-y-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-y-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-y-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-y-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-y-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-y-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-y-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-y-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'K': {
    base: new URL('./otter3d-k.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-k-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-k-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-k-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-k-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-k-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-k-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-k-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-k-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-k-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-k-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-k-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-k-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-k-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-k-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-k-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-k-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-k-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-k-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-k-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-k-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-k-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-k-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-k-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-k-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-k-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-k-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-k-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-k-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-k-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-k-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-k-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-k-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'M': {
    base: new URL('./otter3d-m.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-m-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-m-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-m-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-m-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-m-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-m-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-m-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-m-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-m-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-m-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-m-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-m-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-m-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-m-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-m-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-m-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-m-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-m-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-m-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-m-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-m-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-m-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-m-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-m-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-m-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-m-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-m-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-m-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-m-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-m-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-m-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-m-duo-swimring.png', import.meta.url).pathname,
    },
  },
  'G': {
    base: new URL('./otter3d-g.png', import.meta.url).pathname,
    scarf: new URL('./otter3d-g-scarf.png', import.meta.url).pathname,
    beanie: new URL('./otter3d-g-beanie.png', import.meta.url).pathname,
    straw: new URL('./otter3d-g-straw.png', import.meta.url).pathname,
    captain: new URL('./otter3d-g-captain.png', import.meta.url).pathname,
    flower: new URL('./otter3d-g-flower.png', import.meta.url).pathname,
    glasses: new URL('./otter3d-g-glasses.png', import.meta.url).pathname,
    shades: new URL('./otter3d-g-shades.png', import.meta.url).pathname,
    phones: new URL('./otter3d-g-phones.png', import.meta.url).pathname,
    bowtie: new URL('./otter3d-g-bowtie.png', import.meta.url).pathname,
    swimring: new URL('./otter3d-g-swimring.png', import.meta.url).pathname,
    act: {
      base: new URL('./otter3d-g-act.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-g-act-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-g-act-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-g-act-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-g-act-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-g-act-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-g-act-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-g-act-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-g-act-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-g-act-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-g-act-swimring.png', import.meta.url).pathname,
    },
    duo: {
      base: new URL('./otter3d-g-duo.png', import.meta.url).pathname,
      scarf: new URL('./otter3d-g-duo-scarf.png', import.meta.url).pathname,
      beanie: new URL('./otter3d-g-duo-beanie.png', import.meta.url).pathname,
      straw: new URL('./otter3d-g-duo-straw.png', import.meta.url).pathname,
      captain: new URL('./otter3d-g-duo-captain.png', import.meta.url).pathname,
      flower: new URL('./otter3d-g-duo-flower.png', import.meta.url).pathname,
      glasses: new URL('./otter3d-g-duo-glasses.png', import.meta.url).pathname,
      shades: new URL('./otter3d-g-duo-shades.png', import.meta.url).pathname,
      phones: new URL('./otter3d-g-duo-phones.png', import.meta.url).pathname,
      bowtie: new URL('./otter3d-g-duo-bowtie.png', import.meta.url).pathname,
      swimring: new URL('./otter3d-g-duo-swimring.png', import.meta.url).pathname,
    },
  },
};
